import React, { useEffect, useState } from 'react'
import { Divider, Paper, Button } from '@mui/material'
import { useParams } from 'react-router-dom'
import api from '../../API/api';
import { Helmet } from "react-helmet";

const CourseOverview = () => {

    const params = useParams();


    useEffect(() => {
        // console.log(params);
        getCourseDetails();
    }, []);

    const [course, setCourse] = useState();
    const [school, setSchool] = useState();
    const getCourseDetails = () => {
        api.getCourseDetails(params.name).then((res) => {
            // console.log(res);
            setCourse(res.data.course);
            setSchool(res.data.school);
        })
            .catch((err) => {
                // console.log(err.response);
            })
    }




    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{course && course.metaTitle}</title>
                <meta name="description" content={course && course.metaDesc} />

            </Helmet>


            <div className='pt-1'>
                <Paper>
                    <div className="col-12 p-2">
                        <div className="row">
                            <div className="col-md-12">
                                <div className='m-3 text-center'>
                                    {/* <Button variant='contained' color='error'>{school && school.schoolName} </Button> */}
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                {course &&
                                    <Paper elevation={3}>
                                        <div className='p-3'>
                                            <div className='text-center'>
                                                <h2>{course && course.courseName}</h2>
                                            </div>
                                            <Divider color='dark' />
                                            <div >
                                                <p className='m-2'>
                                                    <div>
                                                        <b> Course Durations: <i> {course && course.duration} Years {course.isInternship && <>(With Internship)</>}</i>
                                                        </b>
                                                    </div>
                                                    <div>
                                                        <b> Eligibility: </b><i> {course && course.eligibility} </i>

                                                    </div>

                                                    <div className='my-4'>
                                                        <b>About The Course</b>

                                                        <div dangerouslySetInnerHTML={{ __html: course.courseOverview }} />
                                                    </div>
                                                    <div className='my-4'>
                                                        <b>Affilited to</b>

                                                        <div>{course && course.affilited}</div>
                                                    </div>
                                                </p>
                                            </div>
                                        </div>
                                    </Paper>
                                }
                            </div>


                            {course &&
                                <div className="col-md-6">
                                    <div>
                                        <Paper elevation={3}>
                                            <div className='p-3'>
                                                <div className='text-center'>
                                                    <h2>Career Opportunities</h2>
                                                </div>
                                                <Divider color='dark' />
                                                <div className=''>
                                                    <div dangerouslySetInnerHTML={{ __html: course.careerOpportunities }} />
                                                </div>
                                            </div>
                                        </Paper>
                                    </div>
                                    <div className='my-2'>
                                        <Paper elevation={3}>
                                            <div className='p-3'>
                                                <div className='text-center'>
                                                    {/* <h2>Recognitions</h2> */}
                                                </div>
                                                {/* <Divider color='dark' /> */}
                                                <div className=''>
                                                    <b>Recognitions: {course.recognition} </b>
                                                </div>
                                            </div>
                                        </Paper>
                                    </div>


                                </div>
                            }




                        </div>


                        <div className="row">
                            <div className="col-md-12">
                                {school &&
                                    <div className="my-4">
                                        <Paper elevation={3}>
                                            <div className='p-3'>

                                                <div className='text-center'>
                                                    <h2>{school && school.schoolName}</h2>
                                                </div>
                                                <Divider color='dark' />
                                                <div className='m-2'>
                                                    <div>
                                                        <div dangerouslySetInnerHTML={{ __html: school.schoolOverview }} />
                                                    </div>
                                                    <div>
                                                        {/* <b> <small> {school && school.principalDesig} </small> </b> */}
                                                    </div>


                                                </div>
                                            </div>

                                        </Paper>
                                    </div>
                                }
                            </div>
                        </div>

                    </div>
                </Paper>
            </div>
        </>
    )

}

export default CourseOverview